export const POST_TASKS_TO_INCIDENT = 'POST_TASKS_TO_INCIDENT';
export const POST_TASKS_TO_INCIDENT_START = `${POST_TASKS_TO_INCIDENT}_START`;
export const POST_TASKS_TO_INCIDENT_SUCCESS = `${POST_TASKS_TO_INCIDENT}_SUCCESS`;
export const POST_TASKS_TO_INCIDENT_FAIL = `${POST_TASKS_TO_INCIDENT}_FAIL`;

export const postTasksToIncidentFromTaskList = (incidentUuid, taskListUuid) => {
  return {
    type: POST_TASKS_TO_INCIDENT,
    meta: {
      xmApi: true,
      method: 'post',
      uri: `/api/xm/1/incidents/${incidentUuid}/task-list-imports`,
      params: {
        taskListIds: [{ id: taskListUuid }],
      },
    },
  };
};
